import { Box, styled, Typography } from "@mui/material";
import { FAIRTRADE_FONT_STACK, FAIRTRADE_TITLE_FONT_STACK } from "./constants";

export const PageTitle = styled(Typography)(() => ({
  fontWeight: 700,
  fontSize: '32px',
  fontFamily: FAIRTRADE_TITLE_FONT_STACK,
  marginTop: '18px',
}))


export const PageWrapper = styled(Box)(({ theme }) => ({
  display: 'flex',
  boxSizing: 'border-box',
  flexDirection: 'column',
  position: 'relative',
  marginLeft: 'auto',
  marginRight: 'auto',
  paddingBottom: '20px',
  width: '100%',
  maxWidth: '800px',
  fontFamily: FAIRTRADE_FONT_STACK,
  fontStyle: 'normal',
  paddingLeft: '8px',
  overflow: 'hidden',
  '& h1, & h2, & h3, & h4, & h5, & h6': {
    fontFamily: FAIRTRADE_TITLE_FONT_STACK,
    fontStyle: 'normal',
  },
  [theme.breakpoints.up('md')]: {
    paddingLeft: '24px',
    paddingRight: '24px',
  },
}))

export const InnerPageWrapper = styled(Box)(({ theme }) => ({
  display: 'flex',
  boxSizing: 'border-box',
  flexDirection: 'column',
  width: '100%',
  paddingLeft: '6px',
  paddingRight: '6px',
  [theme.breakpoints.up('md')]: {
    paddingLeft: '0px',
    paddingRight: '0px',
  },
}))
